import { Reservation } from 'src/types/reservation'

const useUnmarkAsPurchasedEligible = (reservation: Reservation) =>
  !!reservation.regItem?.isFavor ||
  (reservation.isPurchased && !reservation.isGroupGiftContribution)

export default useUnmarkAsPurchasedEligible
